<template>
  <div class="public-cdk-page">
    <main class="public-cdk-main">
      <section class="public-cdk-intro">
        <div class="public-cdk-badge"><i class="el-icon-key"></i> 授权兑换中心</div>
        <h1>兑换码查询与批量兑换</h1>
        <p>输入软件名称和授权口令，查询对应的兑换码记录。</p>
      </section>

      <section class="public-cdk-access">
        <el-form inline @submit.native.prevent="authorize">
          <el-form-item label="软件名称">
            <el-input v-model.trim="proxyName" clearable placeholder="请输入软件名称" />
          </el-form-item>
          <el-form-item label="授权口令">
            <el-input v-model.trim="remark" clearable show-password placeholder="请输入授权口令" />
          </el-form-item>
          <el-button type="primary" :loading="accessLoading" @click="authorize">进入查询</el-button>
        </el-form>
        <div class="public-cdk-security-tip"><i class="el-icon-lock"></i> 授权口令对应兑换码备注，未设置备注的兑换码不支持公共查询。</div>
      </section>

      <section v-if="unlocked" class="public-cdk-records">
        <el-form :inline="true" size="small" class="public-cdk-filters" @submit.native.prevent>
          <el-form-item label="套餐">
            <el-select v-model="filterVipid" class="pc-w-pkg" placeholder="全部" @change="searchRecords">
              <el-option label="全部" :value="''">
                <span>全部</span>
                <span class="pc-option-count">{{ summaryTotal }} 个</span>
              </el-option>
              <el-option v-for="item in packageSummary" :key="item.vipid" :label="item.name" :value="item.vipid">
                <span>{{ item.name }}</span>
                <span class="pc-option-count">{{ item.total }} 个 · 未用 {{ item.unused }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="usageStatus" class="pc-w-sm" @change="searchRecords">
              <el-option label="全部" value="all" />
              <el-option label="未使用" value="unused" />
              <el-option label="已使用" value="used" />
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearable class="pc-w-date"
              @change="searchRecords" />
          </el-form-item>
          <el-form-item label="搜索">
            <el-select v-model="searchType" class="pc-w-sm">
              <el-option label="兑换码" value="name" />
              <el-option label="备注" value="remark" />
              <el-option label="激活用户" value="username" />
            </el-select>
            <el-input v-model="keyword" clearable class="pc-w-md"
              :placeholder="searchPlaceholder"
              prefix-icon="el-icon-search" @keyup.enter.native="searchRecords" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchRecords">查询</el-button>
            <el-button @click="resetFilters">重置</el-button>
          </el-form-item>
        </el-form>

        <div class="public-cdk-actions">
          <el-button type="success" size="small" icon="el-icon-circle-check" :disabled="!selectedRows.length"
            @click="openBatchRedeem">批量兑换</el-button>
        </div>

        <el-table class="public-cdk-table" :data="records" v-loading="loading" :row-class-name="usedRowClass"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="48" />
          <el-table-column prop="name" label="兑换码（点击可复制）" min-width="180">
            <template slot-scope="scope">
              <span class="code-link" @click="copyText(scope.row.name)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="套餐信息" min-width="170">
            <template slot-scope="scope">{{ formatPackage(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="username" label="激活用户" min-width="120" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <span class="status-dot" :class="scope.row.status === 1 ? 'unused' : 'used'"></span>
              {{ scope.row.status === 1 ? '未使用' : '已使用' }}
            </template>
          </el-table-column>
          <el-table-column prop="intime" label="日期" width="155">
            <template slot-scope="scope">{{ formatDate(scope.row.intime) }}</template>
          </el-table-column>
        </el-table>

        <div class="public-cdk-mobile-list">
          <div class="public-cdk-mobile-selection">
            <el-checkbox :value="isAllSelected" :indeterminate="isPartiallySelected" @change="toggleSelectAll">
              全选本页
            </el-checkbox>
            <span>已选择 {{ selectedRows.length }} 条</span>
          </div>
          <div v-for="(item, index) in records" :key="item.id" class="public-cdk-mobile-card"
            :class="{ 'cdk-used-card': item.status !== 1 }">
            <div class="mobile-card-head">
              <el-checkbox :value="isSelected(item)" @change="toggleSelection(item, $event)">#{{ index + 1 }}</el-checkbox>
              <span class="mobile-package">{{ formatPackage(item) }}</span>
            </div>
            <div class="mobile-card-line">
              <span>兑换码</span>
              <span class="mobile-code" @click="copyText(item.name)">
                {{ item.name }}<i class="el-icon-document-copy"></i>
              </span>
            </div>
            <div class="mobile-card-line"><span>激活用户</span><span>{{ item.username || '未激活' }}</span></div>
            <div class="mobile-card-line"><span>状态</span><span><i class="status-dot" :class="item.status === 1 ? 'unused' : 'used'"></i>{{ item.status === 1 ? '未使用' : '已使用' }}</span></div>
            <div class="mobile-card-line"><span>日期</span><span>{{ formatDate(item.intime) }}</span></div>
          </div>
        </div>

        <div class="public-cdk-pagination">
          <span class="public-cdk-total">共 {{ total }} 条</span>
          <el-select v-model="pageSize" size="small" class="public-cdk-page-size" @change="changePageSize">
            <el-option v-for="size in [10, 20, 50, 100]" :key="size" :label="`${size}条/页`" :value="size" />
          </el-select>
          <el-pagination small layout="prev, pager, next" :current-page="page" :page-size="pageSize"
            :total="total" @current-change="changePage" />
        </div>
      </section>
    </main>

    <el-dialog title="批量兑换" :visible.sync="batchVisible" custom-class="public-batch-dialog">
      <el-alert title="用户名支持换行、空格、逗号和分号分割，并按兑换码顺序一一对应。" type="info" :closable="false" show-icon />
      <el-input v-model="batchUsernames" type="textarea" :rows="6" placeholder="请粘贴用户名，每行一个"
        style="margin-top: 14px;" />
      <div class="batch-count" :class="{ error: parsedUsernames.length !== batchRows.length }">
        已选 {{ batchRows.length }} 个兑换码，识别到 {{ parsedUsernames.length }} 个用户名
      </div>
      <div class="public-batch-preview">
        <div v-for="(item, index) in batchPreview" :key="item.id" class="public-batch-item">
          <div><b>#{{ index + 1 }} {{ item.name }}</b><span class="mobile-package">{{ formatPackage(item) }}</span></div>
          <span :class="{ error: !item.username }">{{ item.username || '待输入用户名' }}</span>
          <em v-if="item.result" :class="item.result.success ? 'success' : 'error'">{{ item.result.msg }}</em>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="batchVisible = false">关闭</el-button>
        <el-button type="primary" :loading="batchLoading" :disabled="!canSubmitBatch" @click="submitBatch">确认批量兑换</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PublicCdk',
  data() {
    return {
      proxyName: '',
      remark: '',
      unlocked: false,
      accessLoading: false,
      loading: false,
      records: [],
      selectedRows: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchType: 'name',
      keyword: '',
      usageStatus: 'all',
      dateRange: [],
      filterVipid: '',
      packageSummary: [],
      summaryTotal: 0,
      batchVisible: false,
      batchRows: [],
      batchUsernames: '',
      batchResults: [],
      batchLoading: false,
    }
  },
  computed: {
    searchPlaceholder() {
      const map = { name: '搜索兑换码', remark: '搜索备注', username: '搜索激活用户' }
      return map[this.searchType] || '搜索兑换码'
    },
    parsedUsernames() {
      return this.batchUsernames.split(/[\s,，;；]+/).map(item => item.trim()).filter(Boolean)
    },
    batchPreview() {
      return this.batchRows.map((item, index) => ({
        ...item,
        username: this.parsedUsernames[index] || '',
        result: this.batchResults[index] || null,
      }))
    },
    canSubmitBatch() {
      return !this.batchLoading && this.batchRows.length > 0 && this.batchRows.every(item => item.status === 1)
        && this.parsedUsernames.length === this.batchRows.length
    },
    isAllSelected() {
      return this.records.length > 0 && this.records.every(item => this.isSelected(item))
    },
    isPartiallySelected() {
      return this.selectedRows.length > 0 && !this.isAllSelected
    },
  },
  methods: {
    async authorize() {
      if (!this.proxyName || !this.remark) {
        this.$message.warning('请输入软件名称和授权口令')
        return
      }
      this.accessLoading = true
      this.unlocked = false
      try {
        const ok = await this.fetchRecords(1)
        if (ok) {
          this.unlocked = true
          this.fetchSummary()
        }
      } finally {
        this.accessLoading = false
      }
    },
    async fetchRecords(page = this.page) {
      this.loading = true
      try {
        const params = {
          proxy_name: this.proxyName,
          remark: this.remark,
          page,
          page_size: this.pageSize,
          keyword: this.keyword,
          search_type: this.searchType,
          usage_status: this.usageStatus,
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date = this.dateRange[1]
        }
        if (this.filterVipid !== '') {
          params.vipid = this.filterVipid
        }
        const res = await this.$ajax.get('api/v1/users/public-cdk/cdks', { params })
        if (!res.data || res.data.status !== 200) throw new Error(res.data && res.data.msg)
        const data = res.data.data || {}
        this.records = data.items || []
        this.total = data.total || 0
        this.page = page
        this.selectedRows = []
        return true
      } catch (error) {
        this.$message.error(this.getRequestErrorMessage(error, '授权验证失败'))
        return false
      } finally {
        this.loading = false
      }
    },
    searchRecords() {
      this.fetchRecords(1)
    },
    resetFilters() {
      this.filterVipid = ''
      this.usageStatus = 'all'
      this.searchType = 'name'
      this.keyword = ''
      this.dateRange = []
      this.fetchRecords(1)
    },
    // 套餐维度统计（可选接口，失败不影响列表，只留控制台）
    async fetchSummary() {
      if (!this.proxyName || !this.remark) return
      try {
        const res = await this.$ajax.get('api/v1/users/public-cdk/summary', {
          params: { proxy_name: this.proxyName, remark: this.remark },
        })
        const body = res.data || {}
        if (body.status !== 200) throw new Error(body.msg || '统计失败')
        this.packageSummary = body.data || []
        this.summaryTotal = Number(body.total || 0)
      } catch (error) {
        this.packageSummary = []
        this.summaryTotal = 0
        console.error('获取套餐统计失败:', error)
      }
    },
    changePage(page) {
      this.fetchRecords(page)
    },
    changePageSize() {
      this.fetchRecords(1)
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || []
    },
    // 已使用的兑换码整行置灰
    usedRowClass({ row }) {
      return row && row.status === 1 ? '' : 'cdk-row-used'
    },
    isSelected(item) {
      return this.selectedRows.some(row => row.id === item.id)
    },
    toggleSelection(item, checked) {
      const rows = this.selectedRows.filter(row => row.id !== item.id)
      if (checked) rows.push(item)
      this.selectedRows = rows
    },
    toggleSelectAll(checked) {
      this.selectedRows = checked ? this.records.slice() : []
    },
    openBatchRedeem() {
      if (!this.selectedRows.length) return this.$message.warning('请先选择兑换码')
      if (this.selectedRows.some(item => item.status !== 1)) return this.$message.warning('只能选择未使用的兑换码')
      this.batchRows = this.selectedRows.map(item => ({ ...item }))
      this.batchUsernames = ''
      this.batchResults = []
      this.batchVisible = true
    },
    async submitBatch() {
      if (!this.canSubmitBatch) return
      this.batchLoading = true
      this.batchResults = []
      try {
        const items = this.batchRows.map((item, index) => ({ cdk_id: item.id, username: this.parsedUsernames[index] }))
        const res = await this.$ajax.post('api/v1/users/public-cdk/cdks/batch-redeem', {
          proxy_name: this.proxyName,
          remark: this.remark,
          items,
        })
        if (!res.data || res.data.status !== 200) throw new Error(res.data && res.data.msg)
        const data = res.data.data || {}
        this.batchResults = data.results || []
        this.$message.success(`兑换完成：成功 ${data.success_count || 0} 个，失败 ${data.failed_count || 0} 个`)
        this.fetchRecords(this.page)
        this.fetchSummary()
      } catch (error) {
        this.$message.error(this.getRequestErrorMessage(error, '批量兑换失败'))
      } finally {
        this.batchLoading = false
      }
    },
    getRequestErrorMessage(error, fallback) {
      const responseData = error && error.response && error.response.data
      if (responseData) {
        if (typeof responseData === 'string') {
          try {
            const parsed = JSON.parse(responseData)
            const parsedMessage = parsed.detail || parsed.msg || parsed.message
            if (parsedMessage) return Array.isArray(parsedMessage) ? parsedMessage.join('；') : String(parsedMessage)
          } catch (e) {
            return responseData
          }
        } else {
          const message = responseData.detail || responseData.msg || responseData.message
          if (message) return Array.isArray(message) ? message.join('；') : String(message)
        }
      }
      return (error && error.message) || fallback
    },
    // 单条兑换码快速复制，无需勾选
    copyText(text) {
      if (!text) return
      const area = document.createElement('textarea')
      area.value = text
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.appendChild(area)
      area.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制 ' + text)
      } catch (error) {
        this.$message.warning('复制失败，请手动复制')
      }
      document.body.removeChild(area)
    },
    formatPackage(item) {
      if (item.type === 1) return `点数 · ${item.fs || 0}点`
      return `月卡 · ${item.fs || 0}个月 · ${item.limtsecond ? `每日${item.limtsecond}次` : '每日不限'}`
    },
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      const pad = value => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
  },
}
</script>

<style scoped>
.public-cdk-page { min-height: 100vh; background: #f5f7fa; color: #1e293b; }
.public-cdk-main { max-width: 1120px; margin: 0 auto; padding: 48px 20px 70px; }
.public-cdk-intro { text-align: center; }
.public-cdk-badge { display: inline-block; padding: 6px 12px; border-radius: 18px; background: #dbeafe; color: #2563eb; font-size: 13px; }
.public-cdk-intro h1 { margin: 16px 0 8px; font-size: 30px; }
.public-cdk-intro p { margin: 0 0 28px; color: #64748b; }
.public-cdk-access, .public-cdk-records { padding: 22px; margin-bottom: 20px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(30, 41, 59, .05); }
.public-cdk-access { text-align: center; }
.public-cdk-access .el-form-item { margin-bottom: 0; }
.public-cdk-security-tip { margin-top: 4px; color: #64748b; font-size: 12px; }
/* 筛选表单：带标签，避免多个下拉看不出用途（label/content 是 el-form-item 内部节点，必须用 >>> 穿透 scoped） */
.public-cdk-filters { margin-bottom: 4px; }
.public-cdk-filters .el-form-item { margin-right: 18px; margin-bottom: 12px; }
.public-cdk-filters >>> .el-form-item__label { padding-right: 8px; color: #64748b; font-size: 13px; }
.public-cdk-filters >>> .el-form-item__content { display: flex; align-items: center; gap: 8px; }
/* el-form-item__content 自带的 clearfix 伪元素会被当成 flex/grid 子项，挤掉一整列 */
.public-cdk-filters >>> .el-form-item__content::before,
.public-cdk-filters >>> .el-form-item__content::after { display: none; }
.pc-w-sm { width: 112px; }
.pc-w-pkg { width: 190px; }
/* 套餐下拉选项右侧的数量 */
.pc-option-count { float: right; margin-left: 18px; color: #94a3b8; font-size: 12px; }
/* 兑换码点击复制 */
.code-link { color: #2563eb; cursor: pointer; }
.code-link:hover { text-decoration: underline; }
.pc-w-md { width: 220px; }
.pc-w-date { width: 268px; }
.public-cdk-actions { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.public-cdk-mobile-selection { display: none; }
.status-dot { display: inline-block; width: 7px; height: 7px; margin-right: 6px; border-radius: 50%; vertical-align: middle; }
.status-dot.unused { background: #10b981; }
.status-dot.used { background: #94a3b8; }

/* 已使用的兑换码置灰（el-table 内部节点需用 >>> 穿透 scoped） */
.public-cdk-page >>> .public-cdk-table .cdk-row-used td,
.public-cdk-page >>> .public-cdk-table .cdk-row-used .cell {
  color: #b0b8c4;
}
.public-cdk-page >>> .public-cdk-table .cdk-row-used .status-dot {
  background: #dfe4ea;
}
.public-cdk-mobile-card.cdk-used-card,
.public-cdk-mobile-card.cdk-used-card .mobile-package,
.public-cdk-mobile-card.cdk-used-card .mobile-card-line,
.public-cdk-mobile-card.cdk-used-card .mobile-card-line > span:first-child {
  color: #b0b8c4;
}
.public-cdk-mobile-card.cdk-used-card .status-dot {
  background: #dfe4ea;
}
.public-cdk-pagination { display: flex; align-items: center; justify-content: flex-end; gap: 10px; margin-top: 18px; }
.public-cdk-total { color: #64748b; font-size: 13px; }
.public-cdk-page-size { width: 92px; }
.public-cdk-pagination .el-pagination { margin-top: 0; }
.public-cdk-mobile-list { display: none; }
.public-batch-preview { max-height: 280px; margin-top: 10px; overflow-y: auto; }
.public-batch-item { display: grid; grid-template-columns: minmax(200px, 1fr) minmax(130px, 1fr) 100px; gap: 12px; align-items: center; padding: 10px 4px; border-bottom: 1px solid #eef2f7; font-size: 13px; }
.public-batch-item .mobile-package { margin-left: 8px; color: #2563eb; }
.batch-count { margin-top: 10px; color: #16a34a; font-size: 13px; }
.batch-count.error, .public-batch-item .error { color: #ef4444; }
.public-batch-item em { font-style: normal; }
.public-batch-item em.success { color: #16a34a; }
.public-batch-item em.error { color: #ef4444; }
.public-cdk-page >>> .public-batch-dialog { width: min(680px, 92vw) !important; }
@media (max-width: 700px) {
  .public-cdk-main { padding: 28px 12px 50px; }
  .public-cdk-intro h1 { font-size: 24px; }
  .public-cdk-access, .public-cdk-records { padding: 14px; }
  .public-cdk-access .el-form { text-align: left; }
  .public-cdk-access .el-form-item { display: block; margin-bottom: 12px; }
  .public-cdk-access .el-form-item__content, .public-cdk-access .el-input { width: 100%; }
  .public-cdk-access > .el-button { width: 100%; }
  /* 手机端筛选区：两列紧凑排布，去掉元素默认 40px 行高带来的一片留白 */
  .public-cdk-filters { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .public-cdk-filters .el-form-item { display: block; margin: 0; }
  .public-cdk-filters >>> .el-form-item__label { display: block; float: none; padding: 0 0 4px; font-size: 12px; line-height: 1.4; text-align: left; }
  .public-cdk-filters >>> .el-form-item__content { display: block; margin-left: 0; font-size: 13px; line-height: normal; }
  .public-cdk-filters >>> .el-form-item__content > * { width: 100%; }
  .public-cdk-filters .pc-w-sm,
  .public-cdk-filters .pc-w-pkg,
  .public-cdk-filters .pc-w-md,
  .public-cdk-filters .pc-w-date { width: 100%; }
  /* 日期 / 搜索 / 按钮跨两列 */
  .public-cdk-filters .el-form-item:nth-child(3),
  .public-cdk-filters .el-form-item:nth-child(4),
  .public-cdk-filters .el-form-item:nth-child(5) { grid-column: 1 / -1; }
  /* 搜索：类型 + 关键词 排一行 */
  .public-cdk-filters >>> .el-form-item:nth-child(4) .el-form-item__content {
    display: grid;
    grid-template-columns: 106px 1fr;
    gap: 8px;
  }
  /* 下拉默认最小宽度由内容撑开，会顶破网格列宽 */
  .public-cdk-filters >>> .el-form-item:nth-child(4) .el-form-item__content > * { min-width: 0; }
  .public-cdk-filters >>> .el-form-item:nth-child(5) .el-form-item__content { display: flex; gap: 10px; }
  .public-cdk-filters >>> .el-form-item:nth-child(5) .el-button { flex: 1; }
  .public-cdk-filters .el-form-item:nth-child(5) .el-button { margin-left: 0; }
  .public-cdk-actions { gap: 12px; margin-bottom: 12px; }
  .public-cdk-actions .el-button { width: 100%; }
  .public-cdk-table { display: none; }
  .public-cdk-mobile-list { display: grid; gap: 8px; }
  .public-cdk-mobile-card { padding: 12px; border: 1px solid #e2e8f0; border-radius: 10px; background: #f8fafc; }
  .mobile-card-head, .mobile-card-line { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
  .mobile-card-head { margin-bottom: 8px; color: #64748b; font-size: 12px; }
  .mobile-package { padding: 3px 7px; border-radius: 10px; background: #dbeafe; color: #1d4ed8; }
  .mobile-code { display: inline-flex; align-items: center; gap: 6px; color: #2563eb; cursor: pointer; word-break: break-all; }
  .mobile-code i { flex-shrink: 0; font-size: 15px; }
  .mobile-card-line { padding: 3px 0; color: #1e293b; font-size: 13px; word-break: break-all; }
  .mobile-card-line > span:first-child { flex-shrink: 0; color: #64748b; }
  .public-cdk-mobile-selection { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; padding: 0 2px; color: #64748b; font-size: 13px; }
  .public-cdk-pagination { justify-content: center; flex-wrap: wrap; gap: 8px; }
  .public-cdk-pagination .el-pagination { width: 100%; text-align: center; }
  .public-cdk-page >>> .public-batch-dialog { margin-top: 5vh !important; }
  .public-cdk-page >>> .public-batch-dialog .el-dialog__body { max-height: 72vh; padding: 14px; overflow-y: auto; }
  .public-batch-item { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 6px; }
  .public-batch-item > div { flex-basis: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/components/PublicCdk.vue